// @flow

import { translate } from '../../../react/features/base/i18n/functions';
import BaseDialog from '../../../react/features/base/ui/components/web/BaseDialog';
import React, { PureComponent } from 'react';

type Props = {

    dialog: ?Object,

    title: String,

    /**
     * Invoked to obtain translated strings.
     */
    t: Function,
    i18n: Object
}


class PopupNotification extends PureComponent<{}, Props, State> {

    render() {
        const { title, t } = this.props;

        return (
            <BaseDialog size='large' className='popup-notification'>
                <article>
                    <h5 className={'text-center color-white'}>
                        {t(title)}
                    </h5>
                </article>
            </BaseDialog>
        );
    }
}

export default translate(PopupNotification);
